<template>
        <div class="side-left-ctn" v-bind:class="{ sidectnopenleft: show }">
           <div class="list-group">
               <div class="row item-result" @click="showImmobile(value)" v-bind:key="key" v-for="(value, key) of results">
                   <div class="col-md-4 imglist">
                       <div class="ctn" :style="'background-image: url(' + value.thumbnail.sizes['256'] + ')'"></div>
                   </div>
                   <div class="col-md-8">
                        <div class="title">{{ value.tipologia.substring(0,30) }}</div>
                        <div class="price"><b>Prezzo:</b> {{ value.price }}</div>
                   </div>
                </div>
           </div>
        </div>
</template>

<script>
export default {
    name: 'LeftSideBar',
    props: ['opened', 'results'],
    methods: {
        showImmobile(value) {
            this.$emit('showimmobile', value);
        }
    },
    mounted() {
    },
    watch: { 
          opened: function(newVal, oldVal) { // watch it
          
          this.show = newVal;
        }
    },
    data() {
        return {
            show: this.opened
        }
    }

}
</script>

<style lang="scss">
    @import './Styles/leftbar.scss';
</style>
